var _linearGradient, _linearGradient2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.995 511.995",
    height: 512,
    viewBox: "0 0 511.995 511.995",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.299,
    x2: 288.299,
    y1: 330.998,
    y2: 30.998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#addcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf6ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.371,
    x2: 220.371,
    y1: 480.998,
    y2: 181.415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5558ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c0ff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Refresh_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510.225 218.923c-2.607-4.878-7.69-7.925-13.228-7.925h-19.512c-21.064-103.491-113.628-180-220.488-180-77.432 0-148.477 39.067-190.049 104.517-4.545 7.156-2.266 16.588 4.937 20.903l51.533 30.923c6.943 4.189 15.894 2.065 20.303-4.688 25.078-38.613 67.427-61.655 113.276-61.655 57.598 0 108.472 36.899 127.295 90h-7.295c-5.537 0-10.62 3.047-13.228 7.925s-2.329 10.796.747 15.396l60 90c2.783 4.175 7.471 6.68 12.48 6.68s9.697-2.505 12.48-6.68l60-90c3.064-4.601 3.357-10.519.749-15.396z",
    fill: "url(#SVGID_1_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m435.349 366.755-46.318-38.599c-6.901-5.725-17.119-4.164-22.046 3.135-25.225 37.383-67.09 59.707-111.987 59.707-57.598 0-108.472-36.899-127.295-90h7.295c5.537 0 10.62-3.047 13.228-7.925s2.329-10.796-.747-15.396l-60-90c-5.566-8.35-19.395-8.35-24.961 0l-60 90c-3.062 4.6-3.354 10.518-.747 15.396s7.69 7.925 13.228 7.925h19.512c21.064 103.491 113.628 180 220.488 180 72.334 0 140.728-35.127 182.93-93.97 4.583-6.387 3.455-15.234-2.58-20.273z",
    fill: "url(#SVGID_2_)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d4a51269.svg";
export { ForwardRef as ReactComponent };